import React, { type FC, type PropsWithChildren, useContext } from 'react';

import { withURL } from '@lucid/utils';
import { withImage } from '@lucid/hooks';

import LayoutContext from '../context/layout-context';
import Image from '../image/image';
import Link from '../link/link';
import type { Lucid } from '../../types/types';

export type BlogImageProps = {
  item: Lucid.Directus.Generated.Blog_Clickable_Image;
};

const BlogImage: FC<PropsWithChildren<BlogImageProps>> = ({ item }) => {
  const { urlLangPrefix, product } = useContext(LayoutContext);

  return (
    <figure
      key={item.id}
      css={theme => ({
        label: 'blogImage',
        margin: `${theme.space.s40}px 0`,
        textAlign: 'center',
      })}
    >
      {item?.link?.final_url ? (
        <Link
          aria-label={item.caption}
          css={{ maxWidth: '80%' }}
          href={withURL(item.link.final_url, { urlLangPrefix, product })}
          title="Image link"
        >
          {item.image && item.image?.filename_disk && (
            <Image imageAlt={item.image.translations?.[0]?.alt || item.caption} imageSrc={withImage(item.image)} />
          )}
        </Link>
      ) : (
        item?.image?.filename_disk && (
          <Image
            css={{ maxWidth: '80%', display: 'inline-block' }}
            imageAlt={item.image.translations?.[0]?.alt! || item.caption}
            imageSrc={withImage(item.image)}
          />
        )
      )}
      {item?.caption && (
        <figcaption
          css={theme => ({
            fontStyle: 'italic',
            fontSize: theme.fontSizes.fs12,
            color: theme.colors.coolGrey[60],
            marginTop: theme.space.s8,
          })}
        >
          {item.caption}
        </figcaption>
      )}
    </figure>
  );
};

export default BlogImage;
